var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWordHighlighters = function SvgWordHighlighters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.848 104"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 215",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6cc959",
    stroke: "#4aad52",
    d: "M.5 24.411h211.848v29.686H.5z",
    "data-name": "Rectangle 2"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#7a7a7a",
    "data-name": "Our newstrawberry flavoris made withreal juice",
    fontFamily: "Calibri-Bold, Calibri",
    fontSize: 23,
    fontWeight: 700,
    transform: "translate(103.83 17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41,
    y: 0
  }, "Our new"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#fff",
    fontSize: 27
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -96,
    y: 27
  }, "strawberry flavor")), /*#__PURE__*/React.createElement("tspan", {
    x: -61,
    y: 54
  }, "is made with"), /*#__PURE__*/React.createElement("tspan", {
    x: -43,
    y: 81
  }, "real juice")))));
};
export default SvgWordHighlighters;